import getCardTypes from "credit-card-type";

import {
  notAllowedCreditCardNetwork,
  unformatCardInput,
} from "cc-tools/helpers";
import type { CardAllowedNetwork } from "cc-tools/types";

import type { CreditCardNetwork } from "chameleon/lib/components/display-cards/display-cards";

export const cardNetworkValidator = (
  value: string,
  // for custom merchant type payment cards
  allowedCardNetworks: Array<CreditCardNetwork>
): CardAllowedNetwork => {
  // If we don't know have any allowed cards assume all can be used
  if (allowedCardNetworks.length === 0) {
    return { isAllowedCardNetwork: true };
  }

  const rawCardValue: string = unformatCardInput(value);
  // Ready to determine Possible CC
  const possibleCardTypes = getCardTypes(rawCardValue);
  // Loop through card nice type vs allowed options
  if (notAllowedCreditCardNetwork(possibleCardTypes, allowedCardNetworks)) {
    return { isAllowedCardNetwork: false };
  }

  return { isAllowedCardNetwork: true };
};
